import axios from "axios"
if (localStorage.getItem("userAuthEnseignant")) {
  var userAuthEnseignant = JSON.parse(localStorage.getItem("userAuthEnseignant"))
  var token = userAuthEnseignant.user.api_token
}
export default axios.create({
  withCredentials: true,
  baseURL: `https://ismsf.enseignant.backcresus-institut.ovh/api/`,
  headers: {
    Authorization: `Bearer ${token}`,
    API_PASSWORD: "aJe6U3h6TT6B9pKS",
    'X-Frame-Options' : "DENY"
  },
})
